// jQuery(document).ready(function() {
//   if(jQuery('[data-js-product-gallery-thumbnail-slider]').length > 0) {
//     jQuery('[data-js-product-gallery-thumbnail-slider]').slick('refresh');
//   }
// })

window.addEventListener("load", (event) => {
  // Home Benefit Section Js Start
  jQuery(document).ready(function () {
    if (jQuery(".home-benefit-section .row").length > 0) {
      jQuery(".home-benefit-section .row").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
  // Home Benefit Section Js End

  // Product(Pump Lock) Section Js Start
  jQuery(document).ready(function () {
    if (jQuery(".box_cover").length > 0) {
      jQuery(".box_cover").slick({
        dots: false,
        arrows: false,
        infinite: true,

        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,

        responsive: [
          {
            breakpoint: 540,
            settings: {
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
  // Product(Pump Lock) Section Js End

  // Product Information Line
  if (jQuery(window).width() <= 1024) {
    jQuery(document).ready(function () {
      if (jQuery(".product-information-line .row").length > 0) {
        jQuery(".product-information-line .row").slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
        });
      }
    });
  }
  // Product Information End
});
